export default "<div class='playlist-content' [@fade]=\"visualState\">\r\n    <ng-template appPlaylistInsert></ng-template>\r\n</div>"